{
  "name": "iotzen-ui-customer-order-track",
  "version": "3.0.8",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && npm run sentry:sourcemaps",
    "build:dev": "ng build --configuration development",
    "build:prod": "ng build --configuration production && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "add": "ng generate component --standalone=true map",
    "update": "ng update @angular/core@18 @angular/cli@18",
    "cf": "ng generate @angular/core:control-flow",
    "ng:add": "ng add @angular/pwa --project iotzen-ui-customer-order-track",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org zendynamix --project iotzen-order-track ./dist && sentry-cli sourcemaps upload --org zendynamix --project iotzen-order-track ./dist"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.21",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.21",
    "@angular/compiler": "^20.3.21",
    "@angular/core": "^20.3.21",
    "@angular/forms": "^20.3.21",
    "@angular/platform-browser": "^20.3.21",
    "@angular/platform-browser-dynamic": "^20.3.21",
    "@angular/router": "^20.3.21",
    "@angular/service-worker": "^20.3.21",
    "@ngrx/effects": "^20.1.0",
    "@ngrx/store": "^20.1.0",
    "@sentry/angular": "^10.45.0",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^20.0.0",
    "leaflet": "^1.9.4",
    "ngx-webcam": "^0.4.1",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "rxjs": "~7.8.1",
    "signature_pad": "^5.0.2",
    "socket.io-client": "^4.7.5",
    "tslib": "^2.6.3"
  },
  "devDependencies": {
    "@angular/build": "^20.3.26",
    "@angular/cli": "~20.3.26",
    "@angular/compiler-cli": "^20.3.21",
    "@ngrx/store-devtools": "^20.1.0",
    "@sentry/cli": "^2.33.1",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~5.1.4",
    "@types/leaflet": "^1.9.12",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.9.3"
  }
}